import { render } from "./QaQcIssueTypes.vue?vue&type=template&id=63518231"
import script from "./QaQcIssueTypes.vue?vue&type=script&lang=js"
export * from "./QaQcIssueTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__